export default __webpack_public_path__ + "6216e59820a143fb7435759dbe860459.svg";